/**
 * 我销售的询比价列表页面地址
 */
export const INUQIRY_AUCTION_SALE_LIST_PAGE_PATH = '/auction/inquiry/list/sale'
